import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const UPSERT_ADMIN_USER_FAIL = "ADMIN_USER:UPSERT_ADMIN_USER_FAIL";

export interface UpsertAdminUserFailAction extends Action {
  type: typeof UPSERT_ADMIN_USER_FAIL;
  organization: OrganizationKeyName;
  errors: undefined | AdminErrorListResponseData;
}

export const upsertAdminUserFailAction = (
  organization: OrganizationKeyName,
  errors?: undefined | AdminErrorListResponseData
): UpsertAdminUserFailAction => ({
  type: UPSERT_ADMIN_USER_FAIL,
  organization,
  errors,
});
